import { Trans, useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface ClipTagProps {
  label?: string;
  icon?: React.ReactNode;
}

export const ClipTag = ({ label, icon }: ClipTagProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={twMerge(
        "inline-flex h-[24px] items-center justify-center gap-[4px] rounded-full border px-[8px] py-[4px]",
        "border-kds-accent-border bg-kds-accent-soft",
      )}
    >
      <span className={twMerge("whitespace-nowrap text-[14px] font-medium leading-[16px]", "text-kds-accent-fg")}>
        <Trans>{t(label || "")}</Trans>
      </span>
      {icon}
    </div>
  );
};
